<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>改标录入记录列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <div class="row" :gutter="20" type="flex" align="middle" justify="start">
      <div
        v-for="item in storehouseIds"
        :key="item.key"
        class="status"
        :class="{ active: form.origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                :inline="true"
                :model="form"
                class="demo-form-inline"
                @keyup.native.enter="search"
              >
                <el-form-item>
                  <el-input
                    v-model="form.gb_user_name"
                    placeholder="改标人"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="form.sku" placeholder="sku编码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="form.dbid" placeholder="打标id"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.wave_picking_no"
                    placeholder="波次单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.user_id"
                    placeholder="用户ID"
                  ></el-input>
                </el-form-item>
                <br />
                <el-form-item>
                  <el-cascader
                    v-model="form.cat_id"
                    placeholder="请选择商品分类"
                    :props="goodsCatProps"
                  ></el-cascader>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.gb_type_id"
                    placeholder="请选择改标类型"
                  >
                    <el-option value="">全部</el-option>
                    <el-option
                      v-for="item in gbTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      >{{ item.name }}</el-option
                    >
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.is_stock_out" placeholder="是否出库">
                    <el-option
                      v-for="item in stockOutOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >{{ item.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.high_quality"
                    placeholder="是否高级质检"
                  >
                    <el-option
                      v-for="item in generalOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >{{ item.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.goods_type" placeholder="商品类型">
                    <el-option
                      v-for="item in goodsTypeMenuSelected"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >{{ item.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
                <br />
                <el-form-item label="入库时间：" style="">
                  <el-date-picker
                    v-model="form.stock_in_time"
                    type="datetimerange"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 370px"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="改标时间：" style="">
                  <el-date-picker
                    v-model="form.gb_input_time"
                    type="datetimerange"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 370px"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button
                    style="margin-left: 10px"
                    type="primary"
                    @click="reset"
                    >重置</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="list" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            height="600"
            :data="list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="dbid"
              label="打标id"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku编码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="first_cat"
              label="一级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="second_cat"
              label="二级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="third_cat"
              label="三级分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stock_in_time"
              label="入库时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gb_input_time"
              label="改标时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gb_user_name"
              label="改标人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gb_type_name"
              label="改标类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_type_str"
              label="商品类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="user_id"
              label="用户id"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_no"
              label="波次单"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="high_quality_text"
              label="是否高级质检"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_stock_out"
              label="是否出库"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button size="mini" @click="handleUpdateType(scope.row)">
                  修改
                </el-button>
                <el-button
                  style="margin-top: 10px; margin-left: 0"
                  type="warning"
                  size="mini"
                  @click="handleDelete(scope.row.id)"
                >
                  删除
                </el-button>
                <el-button
                  style="margin-top: 10px; margin-left: 0"
                  type="info"
                  size="mini"
                  @click="handleViewLog(scope.row.dbid)"
                >
                  操作日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="list" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            :page-sizes="[50, 100]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="count"
            :page-size="form.psize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="改标类型修改"
      :visible.sync="dialogChangeTypeVisible"
      width="600px"
      center
    >
      <el-form
        ref="updateTypeForm"
        :model="updateTypeForm"
        class="radio-group-wrap"
      >
        <div class="radio-group">
          <div class="title">商品类型</div>
          <el-radio-group v-model="updateTypeForm.goods_type">
            <div
              v-for="(item, key) in goodsTypeMenu"
              :key="key"
              style="margin-bottom: 10px"
            >
              <el-radio :label="item.value">
                {{ item.label }}
              </el-radio>
            </div>
          </el-radio-group>
        </div>
        <div class="radio-group type">
          <div class="title">改标类型</div>
          <el-radio-group v-model="updateTypeForm.type">
            <div
              v-for="(item, key) in gbTypeList"
              :key="key"
              style="margin-bottom: 10px"
            >
              <el-radio :label="item.id">
                {{ item.name }}
              </el-radio>
            </div>
          </el-radio-group>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleChangeTypeCancel">
          取 消
        </el-button>
        <el-button size="mini" type="primary" @click="handleChangeTypeConfirm">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showDialogLog" title="操作日志">
      <YsDataTable
        v-model="refreshLog"
        :init-params="initParamsLog"
        :fetch-method="fetchMethodLog"
        :columns="columnsLog"
        :use-pagination="false"
        use-data-field
      ></YsDataTable>
    </el-dialog>
  </div>
</template>

<script>
import * as userLabelConfigApi from "@/controller/userLabelConfig3383.js";
import { getGaiBiaoGoodsTypeEnum } from "@/controller/quality2353.js";
import { postLogs } from "@/openapi/erp/GaiBiao.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    const that = this;
    return {
      dialogChangeTypeVisible: false, // 修改改标类型
      updateTypeForm: {
        dbid: "",
        type: "",
        goods_type: "",
      },
      loading: false,
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      stockOutOption: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 2,
        },
      ],
      generalOption: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 2,
        },
      ],
      goodsTypeMenu: [],
      filterFold: false,
      goodsCatProps: {
        value: "id",
        label: "name",
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          let pid = 0;
          if (level > 0) {
            pid = node.value;
          }
          that
            .getGoodsCategory(pid)
            .then((res) => {
              const temp = res.map((item) => {
                return { ...item, leaf: item.child_count <= 0 };
              });
              resolve(temp);
            })
            .catch((e) => {
              that.$message.error(e.msg);
            });
        },
      },
      gbTypeList: [],
      form: {
        dbid: "",
        goods_no: "",
        cat_id: "",
        wave_picking_no: "",
        sku: "",
        stock_in_time: [],
        gb_input_time: this.defaultDate(1),
        gb_user_name: "",
        is_stock_out: "",
        user_id: "",
        gb_type_id: "",
        origin: 1,
        p: 1,
        psize: 50,
        task: 0,
      },
      list: [],
      count: 0,
      showDialogLog: false,
      refreshLog: false,
      initParamsLog: {},
      fetchMethodLog: postLogs,
      columnsLog: [
        {
          label: "操作人",
          prop: "admin_name",
        },
        {
          label: "操作内容",
          prop: "content",
        },
        {
          label: "操作时间",
          prop: "created_at",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      });
      return this.form;
    },
  },
  mounted() {
    // 获取商品类型列表
    this.getGoodsTypeList();
  },
  methods: {
    handleChangeTypeCancel() {
      this.dialogChangeTypeVisible = false;
      this.$refs.updateTypeForm.resetFields();
    },
    handleChangeTypeConfirm() {
      userLabelConfigApi.updateGbType(this.updateTypeForm).then(() => {
        this.$message.success("保存成功");
        this.dialogChangeTypeVisible = false;
        this.$refs.updateTypeForm.resetFields();
        this.fetchData(true);
      });
    },
    handleUpdateType(row) {
      this.updateTypeForm = {
        id: row.id,
        type: row.gb_type_id,
        goods_type: row.goods_type,
      };
      this.dialogChangeTypeVisible = true;
    },
    handleDelete(id) {
      this.$confirm("删除后该改标数据会被删除，无法恢复", "确认要删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userLabelConfigApi.delGbInputRecord({ id }).then(() => {
          this.$message.success("删除成功");
          this.fetchData(true);
        });
      });
    },
    handleViewLog(dbid) {
      this.initParamsLog = { dbid };
      this.showDialogLog = true;
      this.refreshLog = true;
    },
    getGoodsCategory(pid) {
      const promise = new Promise((resolve, rejected) => {
        this.$http
          .post("/erp/Common/getGoodsCategory", {
            parent_id: pid,
            is_show: 1,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              return rejected(res.data.msg);
            }
            return resolve(res.data.data);
          });
      });
      return promise;
    },
    fetchData(loading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code === 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (loading) {
        this.loading = loading;
      }
      this.$http
        .post("/erp/GaiBiao/getGbInputRecordList", this.filteredForm)
        .then((res) => {
          console.log("res", res);
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (this.form.task) {
            this.$message.success("成功提交导出任务");
          } else {
            this.list = res.data.data.list;
            this.count = res.data.data.count;
            this.gbTypeList = res.data.data.gb_type_list;
            this.form.page = res.data.data.page;
            this.form.psize = res.data.data.pagesize;
          }
        })
        .finally(() => {
          this.form.task = 0;
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    defaultDate(range) {
      return this.$excalibur.getDateTimeOnHours(range, 6);
    },
    search() {
      this.form.page = 1;
      this.form.task = 0;
      this.fetchData(true);
    },
    selectOrigin(origin) {
      this.form.task = 0;
      this.form.origin = origin;
      this.fetchData(true);
    },
    handleCurrentChange(page) {
      this.form.task = 0;
      this.form.page = page;
      this.fetchData(true);
    },
    handleSizeChange(psize) {
      this.form.task = 0;
      this.form.page = 1;
      this.form.psize = psize;
      this.fetchData(true);
    },
    output() {
      this.form.task = 1;
      this.fetchData(true);
    },
    reset() {
      this.form = {
        dbid: "",
        goods_no: "",
        cat_id: "",
        wave_picking_no: "",
        sku: "",
        stock_in_time: [],
        gb_input_time: this.defaultDate(1),
        gb_user_name: "",
        is_stock_out: "",
        user_id: "",
        gb_type_id: "",
        origin: 1,
        p: 1,
        psize: 50,
        task: 0,
      };
      this.fetchData(true);
    },
    getGoodsTypeList() {
      getGaiBiaoGoodsTypeEnum().then((res) => {
        const { da_biao_goods_type_enum: daBiaoGoodsTypeEnum } = res;
        this.goodsTypeMenuSelected = [
          { label: "全部", value: "0" },
          ...daBiaoGoodsTypeEnum,
        ];
        this.goodsTypeMenu = daBiaoGoodsTypeEnum;
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}
.radio-group-wrap {
  display: flex;
}
.radio-group-wrap .radio-group {
  width: 300px;
  padding: 20px;
  border: 1px solid #333;
}
.radio-group-wrap .radio-group .title {
  font-size: 22px;
  margin-bottom: 10px;
}
.radio-group-wrap .radio-group.type {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/GaiBiao/GbInputRecord.vue